<rt-evaluation-dropdown-header
  [heading]="'app.interview.fill_out_form' | translate"
  [canManageInterviewTemplates]="canManageInterviewTemplates()"
  [showBackButton]="true"
  (back)="back.emit()"
/>

@if (allGroupedEvaluationForms().length) {
  <rt-add-evaluation-dropdown-form
    [form]="form"
    [offers]="offers()"
    [groupedTemplates]="visibleTemplates()"
    [templatesLoaded]="templatesLoaded()"
  />
  <rt-divider />
  <rt-add-evaluation-dropdown-footer
    [isFormValid]="isFormValid()"
    (cancel)="close.emit()"
    (submit)="onSubmit()"
  />
} @else {
  <rt-evaluation-dropdown-empty-state />
}
